import classNames from "clsx";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";

export const SkipTraceValidationError = ({ errorMessage }: { errorMessage: string | null }) => {
  const { t } = useTranslation();

  if (!errorMessage) {
    return null;
  }

  return (
    <div
      className={classNames("flex", "flex-row", "gap-2", "items-center")}
      data-testid="create-skip-trace-validation-error"
    >
      <i
        className={classNames("icon-lt-error-warning-line", "text-background-surface-destructive-accent", "text-2xl")}
        data-testid="error-icon"
      />
      <span className={classNames("text-background-surface-destructive-accent", "font-semibold")}>
        {t(errorMessage)}
      </span>
    </div>
  );
};
